<template>
  <div class="form-group">
    <label for="inputId" aria-label="Number" class="form-label">
      {{ label }}
      <span v-if="optionalLabel" class="optional-label">({{ optionalLabel }})</span>
    </label>
    <div class="form-number">
      <button
        type
        class="button form-number__button button--neutral button--icon--only subtract"
        :disabled="disabled"
        @click="onSubtract()"
      >
        Subtract
        <icon class-name="button__icon" name="minus" />
      </button>
      <div :class="[`form-input`, error && `form-input--error`]">
        <input
          id="number"
          type="number"
          placeholder="0"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
          aria-label="number"
          :min="minimumNumber"
          :max="maximumNumber"
          :class="[`form-input__field`, hover && `hover`, focus && `focus`]"
          :disabled="disabled"
          :value="value"
          @input="$emit('input', parseInt($event.target.value))"
        />
      </div>
      <button
        type
        class="button form-number__button button--neutral button--icon--only add"
        :disabled="disabled"
        @click="onAdd()"
      >
        Add
        <icon class-name="button__icon" name="plus" />
      </button>
    </div>
    <p
      v-if="errorMessage"
      class="form-label form-label--error form-label--error--active"
    >{{ errorMessage }}</p>
    <div
      v-if="helpMessage"
      :class="[`form-help`, helpMessagePosition === `right` && `text-right`]"
    >{{ helpMessage }}</div>
  </div>
</template>

<script>
// Components
import Icon from "../Icon/Icon.vue";

export default {
  name: "NumberInput",
  components: {
    Icon,
  },
  props: {
    /**
     * @description
     * Provides Label for Number Input
     */
    label: {
      type: String,
      default: "Number Input",
    },
    /**
     * @description
     * Provides Optional Label for Number Input
     */
    optionalLabel: {
      type: String,
      default: "Optional Label",
    },
    /**
     * @description
     * Provides Error Message for Number Input
     */
    errorMessage: {
      type: String,
      default: "Default Error Message!",
    },
    /**
     * @description
     * Provides Help Message for Number Input
     */
    helpMessage: {
      type: String,
      default:
        "Default Help Message: Nudge up and down or type the number in (1-10)!",
    },
    /**
     * @description
     * Checks the Number Input help message position
     * Maersk Design System CSS Supports only left and right
     */
    helpMessagePosition: {
      type: String,
      validator: (val) => ["left", "right"].includes(val),
      default: "left",
    },
    /**
     * @description
     * Provides the Number Input min number
     */
    minimumNumber: {
      type: Number,
      default: 0,
    },
    /**
     * @description
     * Provides the Number Input max number
     */
    maximumNumber: {
      type: Number,
      default: 10,
    },
    /**
     * @description
     * Emits the value change on input, Parent Component needs to sync values emitted
     */
    value: {
      type: Number,
      required: true,
    },
    /**
     * @description
     * Checks if the Number Input should be disabled
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Number Input should be hoverable
     */
    hover: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Number Input should be focusable
     */
    focus: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Number Input should display error outline
     */
    error: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * @description
     * Emits the Input Value after clicking on the Plus Icon Button
     */
    onAdd() {
      this.$emit("addNumber", parseInt(this.value) + 1);
    },
    /**
     * @description
     * Emits the Input Value after clicking on the Subtract Icon Button
     */
    onSubtract() {
      this.$emit("subtractNumber", parseInt(this.value) - 1);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>